// フィルター条件の型
export interface RecordingFilters {
  customerName?: string;
  customerPhone?: string;
  advisorName?: string;
  recordingStatusId?: number;
  dateFrom?: string; // YYYY-MM-DD
  dateTo?: string; // YYYY-MM-DD
}

const buildNormalizedParams = (page: number, filters: RecordingFilters): URLSearchParams => {
  const params = new URLSearchParams();

  // pageは常にURLに含める（必須パラメータ）
  params.set('page', String(page));

  if (filters.customerName) {
    params.set('customer-name', filters.customerName);
  }
  if (filters.customerPhone) {
    params.set('customer-phone', filters.customerPhone);
  }
  if (filters.advisorName) {
    params.set('advisor-name', filters.advisorName);
  }
  if (filters.recordingStatusId) {
    params.set('status', String(filters.recordingStatusId));
  }
  if (filters.dateFrom) {
    params.set('from', filters.dateFrom);
  }
  if (filters.dateTo) {
    params.set('to', filters.dateTo);
  }

  return params;
};

export default buildNormalizedParams;
